/* eslint-disable import/prefer-default-export */
export const setEvent = (state, event) => {
  state.event = event;
};
export const setGuest = (state, guest) => {
  state.guest = guest;
};
